$(document).ready(function() {
  var pathname = window.location.pathname;
  if(pathname.includes('pages/nps')) {
    var screen_height = $( window ).height();
    var current_header_footer = $('.nav.clearfix').height() + $('.footer').height();
    var nps_height = $('.container.main.content').height();
    if(screen_height > (current_header_footer + nps_height)) {
      $('.footer').addClass('footer-static');
    }
  } else {
    if($('.footer').hasClass('footer-static')) {
      $('.footer').removeClass('footer-static');
    }
  }

  var url = new URL(window.location.href);

  if (url.searchParams.get('msg')) {
    var custom_text = decodeURIComponent(url.searchParams.get('msg'));
    $('.promo_banner__content').html(custom_text);

  }
});

// dinamically update breadcrumb "Products" to collection if set in sessionStorage
// The sessionStorage items are added in collection.liquid template
function updateBreadcrumb() {
  var url = sessionStorage.getItem('collection_url');
  var title = sessionStorage.getItem('collection_title');
  if (url && title) {
    var urlEl = document.getElementById('breadcrumb-collection-url');
    var titleEl = document.getElementById('breadcrumb-collection-title');
    if(urlEl && titleEl) {
      urlEl.href= url;
      titleEl.textContent = title;
    }
  }
}
updateBreadcrumb();

// remove Instantsearch plus(fast simon) autocomplete/search from recharge quick login
jQuery('input[name="verification_code"]').attr('isp_ignore', true);


function adjustAnnouncementBar(){
  if( $(".announcement-bar").length > 0 ){
    $("#header").css('top', $(".announcement-bar").height() + "px");
  }
}



$(document).ready(function(){
  if($(window).width() > 768) {
    adjustAnnouncementBar();

    $(window).resize(() => {
      adjustAnnouncementBar();
    })
  }

  if($('input[name="enable_extra_discount"]').length) {
    const rechargeCheckInterval = setInterval(isRechargeWidgetLoaded, 100);

    function isRechargeWidgetLoaded() {
      if($('[data-widget-container]').length) {
        stopRechargeCheckInterval();
        $('[data-label-discount]').hide();
        $('[data-label-subsave]').hide();
        var extraDiscount = parseInt($('input[name="extra_discount"]').val());
        var originalDiscount = parseInt($('input[name="original_discount"]').val());
        var totalDiscount = extraDiscount+originalDiscount;
        var initialPrice = parseInt($('.swatch-element[data-id="'+$('.shopify-product-form [name="id"]').val()+'"]').data('price'));
        var discountPrice = initialPrice - (totalDiscount / 100) * initialPrice;
        $('[data-label-discount]').text(totalDiscount+"%");
        $('[data-price-subsave]').text("$"+(discountPrice/100).toFixed(2));
        $('[data-label-discount]').show();
        $('[data-label-subsave]').show();
      }
    }

    function stopRechargeCheckInterval() {
      clearInterval(rechargeCheckInterval);
    }
  }

  $('.swatch-element').click(function(){
    var qty = $(this).data('qty');
    var current_qty = $('#quantity').val();
    if(current_qty > qty) {
      $('#quantity').val(qty);
    }
    if($('.inventory-message').length > 0) {
      changeMessage(qty);
    }

    if($('input[name="enable_extra_discount"]').length) {
      var extraDiscount = parseInt($('input[name="extra_discount"]').val());
      var originalDiscount = parseInt($('input[name="original_discount"]').val());
      var totalDiscount = extraDiscount+originalDiscount;

      var initialPrice = parseInt($(this).data('price'));
      var discountPrice = initialPrice - (totalDiscount / 100) * initialPrice;
      $('[data-label-discount]').hide();
      $('[data-label-subsave]').hide();
      setTimeout(function() {
        $('[data-label-discount]').text(totalDiscount+"%");
        $('[data-price-subsave]').text("$"+(discountPrice/100).toFixed(2));
        $('[data-label-discount]').show();
        $('[data-label-subsave]').show();
      },100)

    }
  });

  function changeMessage(qty) {
    var inventory_threshold = $('.inventory-message').data('inventory-threshold');

    if(qty > inventory_threshold) {
      $('.inventory-above').show();
      $('.inventory-below').hide();
    } else {
      $('.inventory-above').hide();
      $('.inventory-below').show();
    }

  }

  if($('.inventory-message').length > 0) {
    changeMessage($('.swatch_options input:checked+.swatch-element').data('qty'));
  }
});

$(document).on('click', '.swatch-element', function(){
  $('.variant-sku').text('SKU: ' + $(this).data('sku'));
});

function updateHeader() {
  if($(window).width() < 768) {
    var ps = $(window).scrollTop();
    var $header = $('#header');
    if (ps <= 0) {
      $header.show();
      $header.removeClass('is-fixed');
    } else if (ps > 0 && ps < 50) {
      $header.hide();
    } else {
      $header.show();
      $header.addClass('is-fixed');
    }
  }
}

$(window).on('load scroll', function(){
  updateHeader();
});

document.addEventListener('rebuy:cart.change', function(event){

  jQuery.getJSON('/cart.js', function(cart) {
    var productItem = cart.item_count;
    $(".cart_container span.cart_count").text(productItem);

  } );

});

// Product subscription
function tdbbsAddShoppingBagSvg() {
  const iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  iconSvg.setAttribute('fill', 'none');
  iconSvg.setAttribute('viewBox', '0 0 16 16');
  iconSvg.setAttribute('width', '16');
  iconSvg.setAttribute('height', '16');

  let iconPath = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'path'
  );
  iconPath.setAttribute('fill-rule', 'evenodd');
  iconPath.setAttribute('clip-rule', 'evenodd');
  iconPath.setAttribute('fill', '#303030');
  iconPath.setAttribute(
    'd',
    'M1.5 3.5C1.5 2.94772 1.94772 2.5 2.5 2.5H13.5C14.0523 2.5 14.5 2.94772 14.5 3.5V12.5C14.5 13.0523 14.0523 13.5 13.5 13.5H2.5C1.94772 13.5 1.5 13.0523 1.5 12.5V3.5ZM13.5 3.5H2.5V12.5H13.5V3.5Z'
  );
  iconSvg.appendChild(iconPath);

  let iconPath2 = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'path'
  );
  iconPath2.setAttribute('fill-rule', 'evenodd');
  iconPath2.setAttribute('clip-rule', 'evenodd');
  iconPath2.setAttribute('fill', '#303030');
  iconPath2.setAttribute(
    'd',
    'M5.5 5C5.77614 5 6 5.22386 6 5.5C6 6.03043 6.21071 6.53914 6.58579 6.91421C6.96086 7.28929 7.46957 7.5 8 7.5C8.53043 7.5 9.03914 7.28929 9.41421 6.91421C9.78929 6.53914 10 6.03043 10 5.5C10 5.22386 10.2239 5 10.5 5C10.7761 5 11 5.22386 11 5.5C11 6.29565 10.6839 7.05871 10.1213 7.62132C9.55871 8.18393 8.79565 8.5 8 8.5C7.20435 8.5 6.44129 8.18393 5.87868 7.62132C5.31607 7.05871 5 6.29565 5 5.5C5 5.22386 5.22386 5 5.5 5Z'
  );
  iconSvg.appendChild(iconPath2);

  let labelEl = document.getElementsByClassName('rc_widget__option--subsave')[0].getElementsByClassName('rc-selling-plans__label')[0];
  labelEl.insertBefore(iconSvg, labelEl.firstChild);
}

function tdbbsAddDiscountDescription() {
  let discount = 30;
  if(typeof window.subscription_discount_amount != "undefined" && window.subscription_discount_amount > -1) {
    discount = window.subscription_discount_amount;
  }
  let html = '<div class="pdo">';

  html += '<div class="pdo__option">';
  html += '<span class="pdo__title">';
  html += 'Save '+discount+'%';
  html += '</span>';
  html += '<span class="pdo__description">';
  html += 'on your<br>first order';
  html += '</span>';
  html += '</div>';

  html += '<svg class="pdo__devider" width="38" height="8" viewBox="0 0 38 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M37.3536 4.35355C37.5488 4.15829 37.5488 3.84171 37.3536 3.64645L34.1716 0.464466C33.9763 0.269204 33.6597 0.269204 33.4645 0.464466C33.2692 0.659728 33.2692 0.976311 33.4645 1.17157L36.2929 4L33.4645 6.82843C33.2692 7.02369 33.2692 7.34027 33.4645 7.53553C33.6597 7.7308 33.9763 7.7308 34.1716 7.53553L37.3536 4.35355ZM0 4.5H37V3.5H0V4.5Z" fill="#007CBB"/></svg>';

  html += '<div class="pdo__option">';
  html += '<span class="pdo__title">';
  html += 'And 10%';
  html += '</span>';
  html += '<span class="pdo__description">';
  html += 'on every<br>future order';
  html += '</span>';
  html += '</div>';

  html += '</div>';
  $(html).insertAfter('.rc-option__subsave .rc_widget__option__selector')
}

$(document).ready(function(){
  const targetNode = document.getElementsByClassName('shopify-product-form')[0];
  let isAdded = false;

  if(!targetNode || isAdded) {
    return;
  }

  const config = { childList: true, subtree: true };

  const callback = function(mutationsList, observer) {
      for(let mutation of mutationsList) {
          if (!isAdded && mutation.type === 'childList' && mutation.target.classList.contains('rc_widget__price--subsave')) {
            tdbbsAddDiscountDescription();
            tdbbsAddShoppingBagSvg();
            isAdded = true;
            return;
          }
          tdbbsShowSubscriptionDiscountPrice();
      }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
  // tdbbsShowSubscriptionDiscountPrice();
})

function tdbbsShowSubscriptionDiscountPrice () {
  const regularPriceEl = $(".modal_price span[content*='.']");
  $('.modal_price .subscription').remove();
  const regularPrice = $('.container.main.content .product .sale-discount span.original').first().html();
  regularPriceEl.html(regularPrice)
  if ($("input[type='radio'][value=subsave]").first().is(':checked')) {
    regularPriceEl.addClass('without-subscription');
    const subscriptionPrice = $('.rc-option__price.rc_widget__price.rc_widget__price--subsave').first().html();
    $('<span class="subscription">' + subscriptionPrice + '</span>').insertBefore(regularPriceEl);
    toggleSalePrice(true);
  } else {
    regularPriceEl.removeClass('without-subscription');
    toggleSalePrice(false);
  }
}

function toggleSalePrice(show){
  //&& $(".rc-radio.rc-option__subsave").length > 0
  if($(".js-product_section .sale-discount").length > 0){
    if(show){
      $(".js-product_section .modal_price.hide-sale-discount").removeClass("hide-sale-discount");
      $(".js-product_section .sale-discount").addClass("hide-sale-discount");
    }else{
      $(".js-product_section .modal_price").addClass("hide-sale-discount");
      $(".js-product_section .sale-discount.hide-sale-discount").removeClass("hide-sale-discount");
    }

    setTimeout(function(){
      var onetime_price = $(".js-product_section .rc-option__price.rc_widget__price--onetime");
      onetime_price.html($(".js-product_section .sale-discount .sale").text().trim());
    }, 50);
  }
}

$('form').on('change', 'input', function() {
  tdbbsShowSubscriptionDiscountPrice();
});

$(document).on('click', '.rc-radio.rc_widget__option', function() {
  const innerInput = $(this).find('input[type="radio"]');
  if ( innerInput.prop('checked') ) {
    return;
  }
  innerInput.prop('checked', true);
  tdbbsShowSubscriptionDiscountPrice();
  const activeClass1 = "rc_widget__option--active";
  const activeClass2 = "rc-option--active";
  $(this).parent().find('.rc-radio').removeClass(activeClass1).removeClass(activeClass2);
  $(this).addClass(activeClass1).addClass(activeClass2);
});

function setCookie(name,value,days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function accountSuccessRedirect() {
  setTimeout(function() {
    window.location.href = "https://www.bestbullysticks.com/pages/rewards-program";
  }, 10000);
}

if($('.account-success').length > 0) {
  accountSuccessRedirect();
}


$(document).ready(function(){
   // Fast simon collections - check if max qty reached - both quick view and add to cart
   $(document).on('click', '.isp_add_to_cart_form .isp_add_to_cart_btn, .isp_quick_view_add_to_cart_form .isp_quick_view_add_to_cart_btn_quick_view', function(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    let btn = $(this),
    form = btn.closest('form'),
    max_qty = btn.attr('data-max-qty'),
    id = form.find('input[name="id"]');
    if(typeof max_qty !== 'undefined' && typeof id !== 'undefined') {
      $.getJSON('/cart.js', function(data) {
        if(typeof data?.items !== 'undefined') {
          let product = data.items.find(pr => pr.id == id.val())
          if(product) {
            if(parseInt(max_qty) > parseInt(product.quantity)) {
              form.submit();
            } else {
              $('<p>You can add up to ' + max_qty + ' items to your cart</>').insertAfter(form);
            }
          } else {
            form.submit();
          }
        }
      });
    } else {
      form.submit();
    }
  });
});
// Set data-in-cart attr to enforce Qty limit on products with limit tags
document.addEventListener('rebuy:cart.change', function(event){
  var formLimit = jQuery('.shopify-product-form #quantity');
  if(event?.detail?.cart?.cart?.items.length > 0 && (formLimit.length && formLimit.data('limit') !== null)) {
    var prodId = jQuery('.shopify-product-form').data('productid');
    event.detail.cart.cart.items.forEach(function(item, index) {
        if(item.product_id == prodId) {
          formLimit.attr('data-in-cart', item.quantity)
        }
    });
  }
});

(() => {
  function fastSimonSerpHooks() {
    window.SerpOptions.registerHook('serp-filters', ({ data, element }) => {
      const $filtersContainer = document.querySelector('#fast-simon-serp-app .filters-container');

      // Loads Klaviyo form
      const klaviyoClass = 'klaviyo-form-W33xpe';
      if (!$filtersContainer.parentElement.querySelector('.' + klaviyoClass)) {
        // Klaviyo banner
        const $klaviyoBanner = document.createElement('div');
        $klaviyoBanner.classList.add(klaviyoClass);
        $filtersContainer.parentElement.append($klaviyoBanner);
      }
        
      // Adds labels for easier customization
      if ($filtersContainer) {
        $filtersContainer.querySelectorAll('.category-container').forEach(($category) => {
          const $title = $category.querySelector('.category-title');
          if ($title) {
            $category.setAttribute('data-category-title', $title.textContent.trim());
          }

          $category.querySelectorAll('.category-items .checkbox').forEach(($checkbox) => {
            const $label = $checkbox.querySelector('.checkbox-label');
            $label.setAttribute('title', $label.querySelector('.filters-option-text').textContent.trim());
          });
        });
      }
    });
  }

  if (window.SerpOptions) {
    fastSimonSerpHooks();
  } else {
    window.addEventListener('fast-serp-ready', function () {
      fastSimonSerpHooks();
    });
  }

function iFrameFirstLoadFix() {
    const fixIframeOnLoad = setInterval(function(){
      if (document.getElementById('vs_full_frame')) {
        let iframe = document.getElementById('vs_full_frame');
        if (!iframe.parentElement.classList.contains('lazyframe')) {
          let lazyframeDiv = document.createElement('div');
          lazyframeDiv.classList.add('lazyframe');
          lazyframeDiv.setAttribute('data-ratio', '16:9');
          let parent = iframe.parentNode;
          parent.removeChild(iframe);
          lazyframeDiv.appendChild(iframe);
          parent.appendChild(lazyframeDiv);
          clearInterval(fixIframeOnLoad);
        } else {
          clearInterval(fixIframeOnLoad);
          if (window.innerWidth <= 1200) {
            let iframeContainer = iframe.parentElement;
            iframeContainer.style.minHeight = "750px";
          }
        }
      }
    }, 100);
  }

  //Check if vs_full_frame exists with setInterval. The interval will run for a duration of 10 seconds.
  let iFrameFinderAttempts = 0;
  const iFrameFinderMaxAttempts = 100;

  const checkIframe = setInterval(function() {
    if (document.getElementById('vs_full_frame')) {
      clearInterval(checkIframe);
      iFrameFirstLoadFix();
    } else if (iFrameFinderAttempts >= iFrameFinderMaxAttempts) {
      clearInterval(checkIframe);
    }
    iFrameFinderAttempts++;
  }, 100);
})();